import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { RouteAwareLinkBuilder } from '@ui/features/route-config/application/services/route-aware-link-builder.service';

/**
 * `/faq` es legacy: el contenido real vive en `/ayuda` (seccion `#faq`, ver
 * `HelpCenterComponent`). El servidor ya hace un 301 (`server-redirects.ts`),
 * pero ese 301 no corre en `ng serve` ni si algo sirve el bundle sin pasar por
 * `server.ts` — este guard asegura que Angular tampoco renderice `FaqComponent`
 * directamente (DEV-2513 - correcciones post SEO).
 */
@Injectable({ providedIn: 'root' })
export class LegacyFaqRedirectGuardService {
    public constructor(
        private readonly router: Router,
        private readonly routeAwareLinkBuilder: RouteAwareLinkBuilder,
    ) {}

    public canActivate(route: ActivatedRouteSnapshot): UrlTree {
        const langCode: string | undefined = route.params['langCode'];
        const currentPath: string = langCode ? `/${langCode}` : '/';
        const targetPath: string = this.routeAwareLinkBuilder.buildLink('/ayuda#faq', currentPath);

        return this.router.parseUrl(targetPath);
    }
}

export const legacyFaqRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot): UrlTree =>
    inject(LegacyFaqRedirectGuardService).canActivate(route);
